import styles from './NotFoundBar.module.css';

const NotFoundBar = () => {
  return (
    <section className={styles.notFoundBar}>
      <h3>Sorry! Page not found</h3>
    </section>
  );
};

export default NotFoundBar;
